import { toCamelCase } from 'js-convert-case'
import { ROLE_DESCRIPTION } from 'utils/constants'

export const USER_ROLES = {
  user: 'User',
  emergencyService: 'Emergency service',
  emergency_service: 'Emergency service',
  principal_accountable_person: 'Principal accountable person',
  principalAccountablePerson: 'Principal accountable person',
  principal_designer: 'Principal designer',
  principalDesigner: 'Principal designer',
  agent: 'User',
  landlord: 'Building owner',
  responsiblePerson: 'Responsible person',
  responsible_person: 'Responsible person',
  prospectivePurchaser: 'Prospective purchaser',
  prospective_purchaser: 'Prospective purchaser',
  owner: 'Admin',
  occupant: 'Occupant'
}
export const userRole = user => USER_ROLES[toCamelCase(user.type)]

export const getRoleDescription = role => {
  switch (role) {
    case 'user':
      return ROLE_DESCRIPTION.user
    case 'agent':
      return ROLE_DESCRIPTION.agent
    case 'landlord':
      return ROLE_DESCRIPTION.landlord
    case 'responsible_person':
      return ROLE_DESCRIPTION.responsiblePerson
    case 'principal_accountable_person':
      return ROLE_DESCRIPTION.principalAccountablePerson
    case 'principal_designer':
      return ROLE_DESCRIPTION.principalDesigner
    case 'occupant':
      return ROLE_DESCRIPTION.occupant
    case 'emergency_service':
      return ROLE_DESCRIPTION.emergencyService
    default:
      return ''
  }
}
